import { z } from 'zod';


export const loginFormSchema = z.object({
  username: z
    .string()
    .min(1, 'El nombre de usuario es requerido'),
  password: z
    .string()
    .min(1, 'La contraseña es requerida'),
});

export type LoginFormData = z.infer<typeof loginFormSchema>;
